import * as React from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import PeopleIcon from '@mui/icons-material/People'
import LinkIcon from '@mui/icons-material/Link'
import UserTable from './index'
import UserTenantTable from '../userTenant'

const UserManagement = () => {
  const [subTab, setSubTab] = React.useState(0)

  return (
    <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        sx={{
          minHeight: 36,
          mb: 1,
          '& .MuiTab-root': {
            minHeight: 36,
            textTransform: 'none',
            fontSize: '0.8rem',
            py: 0.5,
          },
        }}
      >
        <Tab
          icon={<PeopleIcon sx={{ fontSize: 16 }} />}
          iconPosition="start"
          label="Usuarios"
        />
        <Tab
          icon={<LinkIcon sx={{ fontSize: 16 }} />}
          iconPosition="start"
          label="Asignaciones"
        />
      </Tabs>

      <Box sx={{ flexGrow: 1, minHeight: 0, display: subTab === 0 ? 'flex' : 'none', flexDirection: 'column' }}>
        <UserTable />
      </Box>
      <Box sx={{ flexGrow: 1, minHeight: 0, display: subTab === 1 ? 'flex' : 'none', flexDirection: 'column' }}>
        <UserTenantTable />
      </Box>
    </Box>
  )
}

export default UserManagement
